import { useCallback } from 'react';

import useFetch from '../../../../controllers/new-avp-experience/hooks/use-fetch';
import {
	getPreferences,
	updatePreferences as updatePreferencesService,
} from '../../../../services/new-avp-experience/preferences';
import { useAnalytics } from '../../../hooks/use-analytics';

export type UsePreferencesReturn = ReturnType<typeof usePreferences>;

export const usePreferences = (featureGateKey: string, workspaceId: string) => {
	const { fireOperationalEvent } = useAnalytics();

	const { data, loading, error, refetch } = useFetch(getPreferences, [
		workspaceId,
		featureGateKey,
		fireOperationalEvent,
	]);

	const updatePreferences = useCallback(
		async (value: boolean, callback?: () => void) => {
			await updatePreferencesService(workspaceId, featureGateKey, value, fireOperationalEvent);
			refetch();
			if (callback) {
				callback();
			}
		},
		[workspaceId, featureGateKey, fireOperationalEvent, refetch],
	);

	return {
		data,
		loading,
		error,
		updatePreferences,
	};
};
